var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27008 15V8.25302H5.12647V15H7.27008ZM6.19855 7.33128C6.94607 7.33128 7.41136 6.81319 7.41136 6.16575C7.39743 5.50371 6.94609 5 6.21274 5C5.4795 5 5 5.50372 5 6.16575C5 6.81322 5.46518 7.33128 6.18456 7.33128H6.19849H6.19855ZM8.45656 15H10.6002V11.2322C10.6002 11.0305 10.6141 10.8291 10.6707 10.6849C10.8257 10.282 11.1784 9.86475 11.7705 9.86475C12.5462 9.86475 12.8565 10.4835 12.8565 11.3905V15H15V11.1313C15 9.05889 13.9425 8.09462 12.5321 8.09462C11.3757 8.09462 10.868 8.77084 10.5859 9.23141H10.6002V8.25288H8.45661C8.48474 8.88598 8.45661 14.9999 8.45661 14.9999L8.45656 15Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/LinkedinIcon.5a451384b021f2c7b675630d1f5ac474.svg";
export { ForwardRef as ReactComponent };